import { WALLET } from 'constants/popups';
import { openPopup } from 'store/actions';

import {
  IS_MOBILE,
  CURRENT_THEME,
  OPEN_DEPOSIT_TAB,
  NAVIGATION_OPENED,
  NAVIGATION_CLOSED,
  CLOSE_DEPOSIT_TAB,
  NAVIGATION_SECTION_OPENED,
  NAVIGATION_SECTION_CLOSED,
  SET_METAMASK_NETWORK_ERROR,
} from './actionTypes';
import { saveState } from 'utils';

export const navigationOpened = () => ({
  type: NAVIGATION_OPENED,
});

export const navigationClosed = () => ({
  type: NAVIGATION_CLOSED,
});

export const navigationSectionIsOpened = payload => ({
  type: NAVIGATION_SECTION_OPENED,
  payload,
});

export const navigationSectionIsClosed = payload => ({
  type: NAVIGATION_SECTION_CLOSED,
  payload,
});

export const closeDepositTab = () => ({
  type: CLOSE_DEPOSIT_TAB,
});

export const openDepositTab = () => dispatch => {
  dispatch(openPopup(WALLET));
  dispatch({
    type: OPEN_DEPOSIT_TAB,
  });
};
export const isMobileMode = payload => ({
  type: IS_MOBILE,
  payload,
});
export const changeCurrentTheme = payload => {
  saveState('theme', payload);

  return {
    type: CURRENT_THEME,
    payload,
  };
};

export const setHideFrozenAmount = payload => {
  return {
    type: SET_METAMASK_NETWORK_ERROR,
    payload,
  };
};
